import React, { FC, Key, useEffect, useState } from 'react'
import './LeaveAdmin.scss'
import employeeService from '../../../../../Services/employeeService'
import { EmployeeSingleType } from '../../../../../Models/employeeType'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'

export const LeaveForm: FC<{ toggle: () => void }> = ({ toggle }) => {
  const [customers, setCustomers] = useState<EmployeeSingleType[]>([])
  const [sortOrder, setSortOrder] = useState('DESC')
  const [tradersCardNumberStatus, setTradersCardNumberStatus] = useState<boolean | undefined>()
  const [pageNumber, setPage] = useState(1)

  const navigate = useNavigate()
  const [selectedLeaveType, setSelectedLeaveType] = useState<string>()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ user: string }>()

  const getUsers = async () => {
    await employeeService.index(pageNumber, sortOrder, undefined, tradersCardNumberStatus).then(
      (response) => {
        console.log('employeeService', response?.data)

        const dataSet = response?.data.data.dataset
        setCustomers(dataSet)
      },
      (error: { response: { data: { error: string } } }) => {
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  useEffect(() => {
    getUsers()
  }, [])

  const submit = handleSubmit((data) => {
    navigate(`/leave/create/${data.user}/${selectedLeaveType}`)
  })

  return (
    <div className='LeaveForm'>
      <form onSubmit={submit}>
        <div className='form-group'>
          <label htmlFor=''>Select Employee</label>
          <select
            className='form-control mt-2'
            {...register('user', { required: 'field is required' })}
          >
            <option>select</option>
            {customers &&
              customers.map((cust: EmployeeSingleType, index: Key) => (
                <option key={index} value={cust.id}>
                  {cust.firstName} {cust.lastName}
                </option>
              ))}
          </select>

          {errors.user && <div className='invalid-feedback'>{errors.user.message}</div>}
        </div>
        <label htmlFor='' className='mt-3 '>
          Leave Balance
        </label>
        <div className='row'>
          <div className='form-group col-6'>
            <div
              className={`card ${selectedLeaveType === 'annual_leave' && 'active-card'}`}
              onClick={() => setSelectedLeaveType('annual_leave')}
            >
              <div className='card-body row h-100'>
                <div className='title col-12 my-auto'>Annual Leave</div>
                <div className='col-12 my-auto'>
                  <div className='days-count'>22/22</div>
                  <div className='days'>Days</div>
                </div>
              </div>
            </div>
          </div>
          <div className='form-group col-6'>
            <div
              className={`card ${selectedLeaveType === 'maternity_leave' && 'active-card'}`}
              onClick={() => setSelectedLeaveType('maternity_leave')}
            >
              <div className='card-body row h-100'>
                <div className='title col-12 my-auto'>Annual Leave</div>
                <div className='col-12 my-auto'>
                  <div className='days-count'>22/22</div>
                  <div className='days'>Days</div>
                </div>
              </div>
            </div>
          </div>
          <div className='form-group col-6'>
            <div
              className={`card ${selectedLeaveType === 'study_leave' && 'active-card'}`}
              onClick={() => setSelectedLeaveType('study_leave')}
            >
              <div className='card-body row h-100'>
                <div className='title col-12 my-auto'>Study Leave</div>
                <div className='col-12 my-auto'>
                  <div className='days-count'>22/22</div>
                  <div className='days'>Days</div>
                </div>
              </div>
            </div>
          </div>
          <div className='form-group col-6'>
            <div
              className={`card ${selectedLeaveType === 'paternity_leave' && 'active-card'}`}
              onClick={() => setSelectedLeaveType('paternity_leave')}
            >
              <div className='card-body row h-100'>
                <div className='title col-12 my-auto'>Paternity Leave</div>
                <div className='col-12 my-auto'>
                  <div className='days-count'>22/22</div>
                  <div className='days'>Days</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='form-group mt-3'>
          <button className='btn btn-default'>Continue</button>
        </div>
      </form>
    </div>
  )
}
